import { EntityState } from '@ngrx/entity';
import { recipientAdapter } from './recipient.adapter';
import { Recipient } from './recipient.interface';

export type RecipientState = EntityState<Recipient>;

export const initialState: RecipientState = recipientAdapter.getInitialState();
